<template>
<base-modal :modal-title="'Edit Filter'" @save="save()" @close="close">
  <FormulateForm>
    <FormulateInput type="checkbox" v-model="model.active" label="Active" />
    <FormulateInput type="checkbox" v-model="model.exclude" label="Accept leads matching this rule" />
    <FormulateInput type="range" v-model="model.rate" label="Rate" min="0" max="100" validation="required|min:0|max:100" show-value="true" />    
    <FormulateInput type="text" v-model.lazy="model.notes" label="Notes" />
    <FormulateInput type="text" v-model.lazy="model.api_response" label="API Response" />
  </FormulateForm>
</base-modal>
</template>

<script>
 // Load the full build. 
 var _ = require('lodash');
 import BaseModal from 'components/modals/BaseModal';
 
 export default {
   components: {
     BaseModal
   },
   props: {
     filter: {
       type: Object,
       default () {
         return {
             id: null,
             notes: '',
             api_response: '',
             active: false,
             exclude: false,
             rate: 100,
             rule: null
         };
       }
     },
   },
   data () {
     return {
       model: null
     };
   },
   created () {
     this.model = _.clone(this.filter, true);
     if (this.model['id'] == null) {
       this.model.id = this.randomId();
       this.model.is_new = true;
     }
     else {
       this.model.is_new = false;
     }
     //this.fetchDataTypes();
   },
   computed: {
   },
   methods: {
     close() {
       this.$emit('close', true);
     },
     save() {
       this.$emit('save', this.model);
     },
     randomId() {
       var r1 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
       var r2 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
       return "temp_" + r1 + "_" + r2;
     },
   }
 }
</script>


<style>
 .form-dashboard .select2-container {
   width: 100% !important;
 }
 .form-dashboard #reportrange {
   background: rgb(255, 255, 255);
   cursor: pointer;
   padding: 5px 10px;
   border: 1px solid rgb(204, 204, 204);
   display: inline-block;
 }
 .form-dashboard .select2-container--default .select2-selection--single .select2-selection__rendered {
   padding: 6px 12px;
   height: 34px;
   line-height: 1.42857143;
 }
 .form-dashboard .select2-container .select2-selection--single {
   height: 34px;
   border: 1px solid #ccc;
   border-radius: 4px;
 }
 .form-dashboard .select2-container--default .select2-selection--single .select2-selection__arrow {
   position: absolute;
   top: 35%;
   margin-top: -8px;
   right: .5em;
 }
 .form-dashboard .select2-container--default .select2-selection--single .select2-selection__arrow b {
   border-color: #616161 transparent transparent transparent;
 }
 .form-dashboard .comiseo-daterangepicker-triggerbutton.ui-button {
   width: 100%;
   height: 34px;
   padding: 6px 12px;
   font-size: 14px;
   line-height: 1.42857143;
   color: #555;
   background-color: #fff;
   background-image: none;
   border: 1px solid #ccc;
   border-radius: 4px;
 }
 .form-dashboard .dropdown-toggle-filters {
   width: 100%;
   text-align: left;
 }
 .form-dashboard .dropdown-toggle-filters .caret {
   float: right;
   margin: 8px 0;
   color: #616161;
 }

 h3 {
   width: 100%;
   display: inline-block;
 }
 h3 .btn {
   position: sticky;
   left: 100%;
   margin-top: -7px;
   font-size: 1rem!important;
 }
 .formulate-input-element-range-value::after {
   content: '%';
 }
</style>



// WEBPACK FOOTER //
// FilterModal.vue?35566e66